export const other = "Other (please specify full details on manufacturer, dose and reason given)";

export const vaccines = [
    { text: "0.1ml - AJV Vaccine (BCG)", value: "0.1ml - AJV Vaccine (BCG)" },
    { text: "1ml - Engerix B® GlaxoSmithKline (Hepatitis B)", value: "1ml - Engerix B® GlaxoSmithKline (Hepatitis B)" },
    { text: "1ml - HBvaxPRO® MSD (Hepatitis B)", value: "1ml - HBvaxPRO® MSD (Hepatitis B)" },
    { text: "1ml - Havrix Monodose (Hepatitis A)", value: "1ml - Havrix Monodose (Hepatitis A)" },
    { text: "0.5ml - Avaxim (Hepatitis A)", value: "0.5ml - Avaxim (Hepatitis A)" },
    { text: "1ml - Vaqta (Hepatitis A)", value: "1ml - Vaqta (Hepatitis A)" },
    { text: "1ml - Twinrix® GlaxoSmithKline (Hepatitis A+B)", value: "1ml - Twinrix® GlaxoSmithKline (Hepatitis A+B)" },
    { text: "0.5ml - Adrenaline 1:1000", value: "0.5ml - Adrenaline 1:1000" },
    { text: "0.5ml - Revaxis® Sanofi Pasteur (DTP)", value: "0.5ml - Revaxis® Sanofi Pasteur (DTP)" },
    { text: "0.5ml - Menveo GSK UK (Meningitis)", value: "0.5ml - Menveo GSK UK (Meningitis)" },
    { text: "0.5ml - Nimenrix Pfizer Ltd (Meningitis)", value: "0.5ml - Nimenrix Pfizer Ltd (Meningitis)" },
    { text: "0.5ml - Priorix GlaxoSmithLine (MMR)", value: "0.5ml - Priorix GlaxoSmithLine (MMR)" },
    { text: "0.5ml - Bexsero GlaxoSmithKline UK (Meningitis B)", value: "0.5ml – Bexsero GlaxoSmithKline UK (Meningitis B)" },
    { text: "0.5ml - MMRVaxPRO Sanofi Pasteur (MMR)", value: "0.5ml - MMRVaxPRO Sanofi Pasteur (MMR)" },
    { text: "0.5ml - Quadrivalent (Influenza)", value: "0.5ml - Quadrivalent (Influenza)" },
    { text: "0.5ml - Typherix® GlaxoSmithKline (Typhoid)", value: "0.5ml - Typherix® GlaxoSmithKline (Typhoid)" },
    { text: "0.5ml - Typhim Vi® Sanofi Pasteur (Typhoid)", value: "0.5ml - Typhim Vi® Sanofi Pasteur (Typhoid)" },
    { text: "0.5ml - Varilrix® GlaxoSmithKline UK (Varicella)", value: "0.5ml - Varilrix® GlaxoSmithKline UK (Varicella)" },
    { text: "0.5ml - Varivax® Sanofi Pasteur MSD (Varicella)", value: "0.5ml - Varivax® Sanofi Pasteur MSD (Varicella)" },
    {
        text: "1000mg - VZIG Bio Products Laboratory, Elstree (Varicella Immunoglobulin)",
        value: "1000mg - VZIG Bio Products Laboratory, Elstree (Varicella Immunoglobulin)"
    },
    {
        text: "1000mg - VZIG Protein Fractionation Centre, (Varicella Immunoglobulin)",
        value: "1000mg - VZIG Protein Fractionation Centre, (Varicella Immunoglobulin)"
    },
    { text: "As Directed - Mupirocin 2% nasal ointment", value: "As Directed - Mupirocin 2% nasal ointment" },
    { text: "As Directed - Naseptin Nasal Cream", value: "As Directed - Naseptin Nasal Cream" },
    { text: "0.5ml - Repevax Sanofi Pasteur (DTPP)", value: "0.5ml - Repevax Sanofi Pasteur (DTPP)" },
    { text: "0.5ml - Boostrix IPV SmithKline Beecham (Inactivated Polio)", value: "0.5ml - Boostrix IPV SmithKline Beecham (Inactivated Polio)" },
    { text: "Tuberculin PPD 2Tu Statens Serum Institute (SSI)", value: "Tuberculin PPD 2Tu Statens Serum Institute (SSI)" },
    { text: other, value: other }
];

export const vaccineRoute = [
    { text: "Intramuscular", value: "Intramuscular" },
    { text: "Sub-Cutaneous", value: "SubCutaneous" },
    { text: "Intradermal", value: "Intradermal" }
];

export const vaccineSite = [
    { text: "Left Deltoid", value: "LeftDeltoid" },
    { text: "Right Deltoid", value: "RightDeltoid" },
    { text: "Left Forearm", value: "LeftForearm" },
    { text: "Right Forearm", value: "RightForearm" },
    { text: "Left Thigh", value: "LeftThigh" },
    { text: "Right Thigh", value: "RightThigh" }
];
